import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'


export const createPathSlice = createSlice({
  name: 'createPath',
  initialState: {
    prefixFeedback: {},
    businesses:[],
    business: '',
    email:'',
    prefix:'',
    loading:false,
    duplicated:null
 
  },
  reducers: {
    setPrefixFeedbackRedux: (state, action) => {
      const { prefixFeedback } = action.payload
      state.prefixFeedback = prefixFeedback
    },
    setBusinessesRedux: (state, action) => {
        const { businesses } = action.payload
        state.businesses = businesses
      },
      setBusinessRedux: (state, action) => {
        const { business } = action.payload
        state.business = business
      },
      setEmailRedux: (state, action) => {
        const { email } = action.payload
        state.email = email
      },
      setPrefixRedux: (state, action) => {
        const { prefix } = action.payload
        state.prefix = prefix
      },
      setLoadingRedux: (state, action) => {
        const { loading } = action.payload
        state.loading = loading
      },
      setDuplicatedRedux: (state, action) => {
        const { duplicated } = action.payload
        state.duplicated = duplicated
      },
  },
})

export default createPathSlice.reducer;

export const {
    setPrefixFeedbackRedux,
    setBusinessesRedux,
    setBusinessRedux,
    setEmailRedux,
    setPrefixRedux,
    setLoadingRedux,
    setDuplicatedRedux
  
} = createPathSlice.actions

export const getPrefixFeedbackRedux = (state) => state.createPath.email
export const getBusinessesRedux = (state) => state.createPath.businesses
export const getBusinessRedux = (state) => state.createPath.business
export const getEmailRedux = (state) => state.createPath.email
export const getPrefixRedux = (state) => state.createPath.prefix
export const getLoadingRedux = (state) => state.createPath.loading
export const getDuplicatedRedux = (state) => state.createPath.duplicated




